var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-input',{class:{ error: _vm.error },attrs:{"options":_vm.options,"selected":_vm.selected ? _vm.selected.format('HH:mm') : '',"empty-option-label":_vm.$t('formFields.timeslotTimeInput.emptyOption.label')},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }